export const achievements = [
  {
    image: "images/ach1.png",
    title: "Number Of Disease Cases",
    titleArabic: "عدد حالات الأمراض",
    year: null,
    count: 2184,
  },
  {
    image: "images/ach2.png",
    title: "Number Of Orphans Benefiting",
    titleArabic: "عدد الأيتام المستفيدين",
    year: 1992,
    count: 4500,
  },
  {
    image: "images/ach3.png",
    title: "Number Of Pilgrims",
    titleArabic: "عدد الحجاج",
    year: 1995,
    count: 24000,
  },
  {
    image: "images/ach4.png",
    title: "Number Of Students Benefiting",
    titleArabic: "عدد الطلاب المستفيدين",
    year: 1992,
    count: 42738,
  },
  {
    image: "images/ach5.png",
    title: "Number Of Umrah Pilgrims",
    titleArabic: "عدد المعتمرين",
    year: 1995,
    count: 60000,
  },
  {
    image: "images/ach6.png",
    title: "Number Of Needy Families Annually",
    titleArabic: "عدد الأسر المحتاجة سنويًا",
    year: null,
    count: 71111,
  },
  {
    image: "images/ach7.png",
    title: "Number Of Charitable Initiatives",
    titleArabic: "عدد المبادرات الخيرية",
    year: null,
    count: 200,
  },
  {
    image: "images/ach8.png",
    title: "Number Of External Projects",
    titleArabic: "عدد المشاريع الخارجية",
    year: null,
    count: 1744,
  },
  {
    image: "images/ach9.png",
    title: "Number Of Partnerships",
    titleArabic: "عدد الشراكات",
    year: null,
    count: 29,
  },
  {
    image: "images/ach10.png",
    title: "Number Of Internal Projects",
    titleArabic: "عدد المشاريع الداخلية",
    year: null,
    count: 440,
  },
];

export const successPartnersPics = [
  { id: 1, img: "client_1" },
  { id: 2, img: "client_2" },
  { id: 3, img: "client_3" },
  { id: 4, img: "client_4" },
  { id: 5, img: "client_5" },
  { id: 6, img: "client_6" },
  { id: 7, img: "client_7" },
  { id: 8, img: "client_8" },
  { id: 9, img: "client_9" },
  { id: 10, img: "client_10" },
  { id: 11, img: "client_11" },
  { id: 12, img: "client_12" },
  { id: 13, img: "client_13" },
  { id: 14, img: "client_14" },
  { id: 15, img: "client_15" },
];
